import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Meta } from '@/components/Meta';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <>
      <Meta title="404 — Silvana Barbato" />
      <div className="u-container flex min-h-screen flex-col items-center justify-center text-center">
        <p className="font-display text-[28vw] leading-none md:text-[14vw]">404</p>
        <p className="mt-6 max-w-sm text-ink-soft">{t('notfound.text')}</p>
        <Link
          to="/"
          className="mt-8 rounded-full border border-ink px-7 py-3 text-xs uppercase tracking-[0.2em] transition-colors hover:bg-ink hover:text-paper"
        >
          {t('notfound.cta')}
        </Link>
      </div>
    </>
  );
}
